import { render, staticRenderFns } from "./dialogList1.vue?vue&type=template&id=52b1e80e&scoped=true&"
import script from "./dialogList1.vue?vue&type=script&lang=ts&"
export * from "./dialogList1.vue?vue&type=script&lang=ts&"
import style0 from "./dialogList1.vue?vue&type=style&index=0&id=52b1e80e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b1e80e",
  null
  
)

export default component.exports